var product_json = null;
function getProductJSON() {
    return axios.get(location.pathname+'?view=json').then((product) => {
        product_json = product.data
    })
}
function propImages() {
    let id = $('#product_id').val();
    let imgs = product_json.images.all;
    let pos = [];
    let rng = [];
    for (const [k,v] of Object.entries(product_json.variants)) {
        pos.push({i: v.id, p: v.featured_image.position});
    }
    let spos = _.orderBy(pos,['p']);
    spos.forEach((l,i) => {
        let np = spos[i+1];
        rng.push({
            i: l.i, s: l.p, e: (np ? np.p-1 : imgs.length)
        });
    });
    pr = rng.filter(r => { return r.i == id })[0];
    pimgs = imgs.slice(pr.s, pr.e);
  console.log(pimgs);
    fpimgs = [];
    lbimgs = [];
    pimgs.forEach(i => {
        fpimgs.push(`<div class="swiper-slide cursor-pointer"><div class="relative w-full pt-[100%]"><img class="absolute top-0 left-0 w-full h-full object-cover product-image" src="https://${i.replace('//','')}"></div></div>`);
        lbimgs.push(`<img class="w-12 h-12 border border-jet-400/10 object-cover rounded lightbox-image" role="button" aria-label="Change Image" tabindex="0" src="https://${i.replace('//','')}">`)
    });
    $('#productImages').html(fpimgs);
    $('#productLightboxImages').html(lbimgs);
    $('.product-image').click(function(){
        $('#productLightbox').css('display','flex')
    });
    $('.lightbox-image,.product-image').click(function(){
        let src = $(this).attr('src')
        $('#lightboxImage').attr('src',src)
    });
    $('#closeLightbox').click(function(){
        $('#productLightbox').hide()
    })
}

$('.parent-link').click(function(){
    $('i', this).toggleClass('fa-solid fa-chevron-down');
    $('i', this).toggleClass('fa-solid fa-chevron-up');
    $(this).siblings('.child-links').slideToggle()
})

// Initial States
$('#search').hide();
$('#mega-menu').hide();
$('#mobileMenu').hide();

// Open Search
$('.openSearch').click(function(){
    $('#search').fadeToggle();
    $('#mega-menu').fadeOut();
    $('#mobileMenu').fadeOut();
    $('#defaultMenu').show();
    $('#shopChairs').hide();
})

// Close Search
$('#closeSearch').click(function(){
    $('#search').fadeOut();
})

// Open Mega Menu
$('#shop-chairs').click(function(){
    $('#mega-menu').fadeToggle();
    $('#search').fadeOut();
})

// Close Mega Menu
$('#close').click(function(){
    $('#mega-menu').fadeOut();
})

// Open Mobile Menu
$('#openMenu').click(function(){
    $('#mobileMenu').fadeToggle();
    $('#search').fadeOut();
})

// Mobile Menu Toggle State
$(function(){
    $('#shopChairs').hide()
    $('#openChairs').click(function(){
        $('#defaultMenu').hide();
        $('#shopChairs').show();
    })
    $('#back').click(function(){
        $('#defaultMenu').show();
        $('#shopChairs').hide();
    })
})

// Product Tab Menu
$('#tab_menu li:first').addClass('tab-active');
$('#tabs>li:first').show().siblings().hide();
$("#tab_menu li").click(function(){
    let tab = $(this).index()
    $(this).addClass("tab-active").siblings().removeClass("tab-active");
    $("#tabs>li").eq(tab).show().siblings().hide();
})

// FAQ Toggle
$('.faq-body').hide()
$('.faq-title').click(function(){
    $(this).toggleClass('faq-active');
    $('i', this).toggleClass('fa-solid fa-plus');
    $('i', this).toggleClass('fa-solid fa-minus');
    $(this).siblings('.faq-body').slideToggle()
})

// Support Select
$('#supportSelect').change(function(){
    let link = $(this).val()
    window.location = link
})

//Form Functions
$(function() {
  $('#subject').on('change', function() {
    changeForm($(this).val())
  })

  function changeForm(form) {
    $('.pxFormGenerator').hide();
    $('[data-form="'+form+'"]').show();
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('ref') && urlParams.get('ref') === 'esports') {
      const subjectSelect = document.getElementById('subject'); // Get the select element
      if (subjectSelect) {
        subjectSelect.value = 'Esports'; // Set the value to 'esports'
        changeForm('Esports')
        const contactForm = document.getElementById('contact-form');
        if (contactForm) {
            const offsetTop = contactForm.offsetTop;
            window.scrollTo({
                top: offsetTop - 150,
                behavior: 'smooth'
            });
        }
      }
  }
})


$(".product-video").click(function() {
  // console.log(this); 
  if (this.paused) {
    this.play();
    $(this).parent().find('.play-icon-container').css('opacity','0');
  } else {
    this.pause();
    $(this).parent().find('.play-icon-container').css('opacity','1');
  }
});
$(".play-icon-container").click(function() {
  // console.log(this); 
  var video = $(this).parent().find('.iframe_video');
  if (video[0].paused) {
    video[0].play();
    $(this).css('opacity','0');
  } else {
    video[0].pause();
    $(this).css('opacity','1');
  }
});

// Spin Holder
$(function(){
    let frames = $(".spin-holder-spin").data("spin-count");
    $(".spin-holder-spin").spritespin({
        source: $(".spin-holder-spin").data("spin"),
        width: 100,
        height: 100,
        frames: frames,
        sense: -1,
        responsive: !0,
        animate: !1,
        plugins: ["360", "drag", "ease"],
    });
})

$(function(){
    let initialModel = $('.product-variant:checked').attr('data-model');
    let initialSpin = $('.product-variant:checked').attr('data-spin');
    let initialImage = $('.product-variant:checked').attr('data-image');
    let initialPoster = $('.product-variant:checked').attr('data-poster');
    let initialDynamicBullet = $('.product-variant:checked').attr('data-dynamic-point');
    let initialPrice = $('.product-variant:checked').attr('data-price');
    $('#modelViewer').attr('src',initialModel);
    $('#modelViewer').attr('poster',initialPoster);
    if(initialModel) {
      $('#staticProductImage').hide();
      $('#modelViewer').show();
    } else {
      $('#modelViewer').hide();
      $('#staticProductImage').show();
    }
    $('.spin-holder-spin').attr('data-spin',initialSpin);
    $('.spin-holder-spin').spritespin({
        source: initialSpin
    });
    if($('.product-variant:checked').attr('data-available') == "false"){
        $('#AddToCart').attr('disabled',true)
        $('#outOfStock').show()
    }else{
        $('#AddToCart').removeAttr('disabled')
        $('#outOfStock').hide()
    };
    $('#staticProductImage').attr('src', initialImage);
    $('#dynamicBullet').html(initialDynamicBullet);
    $('.product-price').html(initialPrice);
})
$('.product-variant').click(function(e){
    let spin = e.currentTarget.getAttribute('data-spin');
    let model = e.currentTarget.getAttribute('data-model');
    let image = e.currentTarget.getAttribute('data-image');
    let poster = e.currentTarget.getAttribute('data-poster');
    let dynamicBullet = $('.product-variant:checked').attr('data-dynamic-point');
    let price = e.currentTarget.getAttribute('data-price');
    if($('.product-variant:checked').attr('data-available') == "true"){
        $('#product_id').val(e.currentTarget.id);
    };
    $('#staticProductImage').attr('src',image);
    $('#modelViewer').attr('src',model);
    $('#modelViewer').attr('poster',poster);
    if(model) {
      $('#staticProductImage').hide();
      $('#modelViewer').show();
    } else {
      $('#modelViewer').hide();
      $('#staticProductImage').show();
    }
    $('.product_color').html(e.currentTarget.title);
    $('.spin-holder-spin').attr('data-spin', spin);
    $(".spin-holder-spin").spritespin({
        source: spin
    });
    if($('.product-variant:checked').attr('data-available') == "false"){
        $('#AddToCart').attr('disabled',true)
        $('#outOfStock').show()
    }else{
        $('#AddToCart').removeAttr('disabled')
        $('#outOfStock').hide()
    }
    $('#dynamicBullet').html(dynamicBullet);
    $('.product-price').html(price);
    propImages();
});
$('#select-size').on('change', function(e){
  let val = $(this).val();
  console.log(val);
  $('#color-select .colors').addClass('hidden');
  $('#color-select .colors[data-size="'+val+'"]').removeClass('hidden');
  $('#color-select .colors:visible:first .product-variant').click();
});

// Order Tracking
$("#orderLookup").on("submit", function(e){
e.preventDefault();
if($("input#order-number").val().length>0)
    {
        order_track();
    }else{
        $("#orderTrack").hide();
        $("#orderTrackError").show();
    }
});
$('#loaderHolder').hide()
function order_track() {
    Papa.parse("https://dl.dropboxusercontent.com/s/uctjy5xggpn4rrj/OFMWEBSITEOrderTracking.csv", {
        download: !0,
        complete: function(e) {
            var i = 2,
                a = [];
            $('#loaderHolder').show();
            $.each(e, function (k, v) {
                $.each(v, function (k1, v1) {
                    if(v[k1] != '') {
                        var findOrder = $('input#order-number').val();
                        var orderNo = v[k1][9];
                        var poNo = v[k1][0];
                        if(orderNo && (orderNo.indexOf(findOrder) !== -1 || poNo.indexOf(findOrder) !== -1)) {
                            a.push(v[k1]);
                        }
                    }                
                });
            });
            
            if(a.length != 0){
                var boxinfo = '';
                var s = 1;
                $.each(a, function(k2,v2) {
                    boxinfo += '<div class="p-5 rounded-md border border-black"><h5 class="mb-2 font-bold">Box '+s+'</h5><p class="text-jet-400/50" class="po-number">PO Number: <span class="text-jet-400 font-bold">'+a[k2][4]+'</span></p><p class="text-jet-400/50"  class="status">Order Status: <span class="text-jet-400 font-bold">'+a[k2][5]+'</span></p><p class="text-jet-400/50"  class="anticipated-ship">Anticipated Ship Date: <span class="text-jet-400 font-bold">'+a[k2][6]+'</span></p><p class="text-jet-400/50"  class="actual-ship">Actual Ship Date: <span class="text-jet-400 font-bold">'+a[k2][7]+'</span></p><p class="text-jet-400/50"  class="tracking">Tracking Number: <span class="text-jet-400 font-bold">'+a[k2][8]+'</span></p></div>';
                    s++;
                });            
                var content = '<div class="flex flex-col gap-3"><div><p class="text-jet-400/50"  id="order-number">Order Number: <span class="text-jet-400 font-bold">'+a[0][0]+'</span></p><p class="text-jet-400/50"  id="order-date">Order Date: <span class="text-jet-400 font-bold">'+a[0][1]+'</span></p><p class="text-jet-400/50"  id="account">Account: <span class="text-jet-400 font-bold">'+a[0][2]+'</span></p><p class="text-jet-400/50"  id="customer">Customer: <span class="text-jet-400 font-bold">'+a[0][3]+'</span></p><p class="text-jet-400/50" id="customer">Total Boxes: <span class="text-jet-400 font-bold">'+a.length+'</span></p></div>'+boxinfo+'</div>';
                $('#orderTrack').html(content);
                $('#loaderHolder').hide();
                $('#orderTrack').show();
                $('#orderTrackError').hide();
            } else {
                $('#loaderHolder').hide();
                $('#orderTrack').hide(); 
                $('#orderTrackError').show();            
            }
        },
    });
}

$('.qty-box .qty-btn').on('click', function(){
    var qty = parseInt($(this).parent('.qty-box').find('.product-form__input').val());
    if($(this).hasClass('qty-plus')) {
        qty++;
    }else {
        if(qty > 0) {
            qty--;
        }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qty-box').find('.product-form__input').val(qty);
    $('.update').trigger('click')
});


// Mobile Collection Filters
$('#showFilters').click(function(){
    $('#collectionFilters').show()
})

$('.close-filters').click(function(){
    $('#collectionFilters').hide()
    $('#colorFilters').hide()
    $('#seriesFilters').hide()
    $('#filtersNav').show()
})

$('#showColorFilters').click(function(){
    $('#colorFilters').show()
    $('#filtersNav').hide()
})

$('#showSeriesFilters').click(function(){
    $('#seriesFilters').show()
    $('#filtersNav').hide()
})

$('.show-filters-nav').click(function(){
    $('#colorFilters').hide()
    $('#seriesFilters').hide()
    $('#filtersNav').show()
})

// Responsive Collection Filters
function filtersResponsive() {
    if ($(window).width() > 1024) {
        $('#collectionFilters').css('display','flex')
        $('#colorFilters').show()
        $('#seriesFilters').show()
    }else{
        $('#collectionFilters').hide()
        $('#colorFilters').hide()
        $('#seriesFilters').hide()
    }
}
$(window).resize(filtersResponsive);

// Order Item Collapse
$('.order-details').hide()
$('.order-item').click(function(){
    $('.order-details', this).slideToggle()
    $('i', this).toggleClass('fa-solid fa-plus');
    $('i', this).toggleClass('fa-solid fa-minus');
})

// Toggle New Address
$('.toggle-new-address').click(function(){
    $('#newAddress').fadeToggle()
})

$('.toggle-edit-address').click(function(){
    $('.edit-address').fadeToggle()
})

// Toggle Forgot Password

$('.toggle-forgot-password').click(function(){
    $('#forgotPassword').toggle()
})


// Mega Menu Change Product
$(function(){
    let first = $('.product-selector:first')
    let title = first.attr('data-title');
    let url = first.attr('data-url');
    let line = first.attr('data-line');
    let bg = first.attr('data-bg');
    let d_one_h = first.attr('data-detail-one-heading');
    let d_one = first.attr('data-detail-one');
    let d_two_h = first.attr('data-detail-two-heading');
    let d_two = first.attr('data-detail-two');
    first.addClass('mega-item-active')
    $('#productTitle').html(title);
    $('#productUrl').attr('href', url);
    $('#lineDrawing').attr('src', line);
    $('#bgImage').attr('src', bg);
    $('#detailOneHeading').html(d_one_h);
    $('#detailOne').html(d_one);
    $('#detailTwoHeading').html(d_two_h);
    $('#detailTwo').html(d_two);
})
$('.product-selector').hover(function(e){
    let title = e.currentTarget.getAttribute('data-title')
    let url = e.currentTarget.getAttribute('data-url');
    let line = e.currentTarget.getAttribute('data-line')
    let bg = e.currentTarget.getAttribute('data-bg');
    let d_one_h = e.currentTarget.getAttribute('data-detail-one-heading');
    let d_one = e.currentTarget.getAttribute('data-detail-one');
    let d_two_h = e.currentTarget.getAttribute('data-detail-two-heading');
    let d_two = e.currentTarget.getAttribute('data-detail-two');
    $(".product-selector").not($(this)).removeClass('mega-item-active');
    $(this).toggleClass('mega-item-active');
    $('#productTitle').html(title);
    $('#productUrl').attr('href', url);
    $('#lineDrawing').attr('src', line);
    $('#bgImage').attr('src', bg);
    $('#detailOneHeading').html(d_one_h);
    $('#detailOne').html(d_one);
    $('#detailTwoHeading').html(d_two_h);
    $('#detailTwo').html(d_two);
})

// Tippy Init
tippy('[data-tippy-content]');